module.exports = require("./../../_gen/starling/display/Sprite");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Sprite.js
// module id = 172
// module chunks = 0